export default {
  "content": "<path d=\"M17.176 3.865h2.76l-6.03 6.892L21 20.135h-5.554l-4.35-5.688-4.979 5.688H3.355l6.45-7.372L3 3.866h5.695l3.933 5.199 4.548-5.2zm-.969 14.618h1.53L7.864 5.43h-1.64l9.983 13.053z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};